import './Header.scss'
import { useState } from 'react'
import cookingIcon from '../assets/cooking-icon.svg'
import menuIcon from '../assets/menu.svg'
import FloatingMenu from './FloatingMenu'
import { getMessage } from '../utils/messageUtils'

interface HeaderProps {
  isMobile: boolean
  tabs: Array<{ id: string; label: string; content: React.ReactElement }>
  activeTab: string
  onTabSelect: (tabId: string) => void
  onLogout: () => void
}

function Header({
  isMobile,
  tabs,
  activeTab,
  onLogout,
  onTabSelect,
}: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <img src={cookingIcon} alt="Meal Planner" className="header-icon" />
          <h1 className="header-title">Meal Planner</h1>
        </div>
        <div className="header-right">
          {isMobile && (
            <button className="menu-button" onClick={toggleMenu}>
              <img src={menuIcon} alt="Menu" className="menu-icon" />
            </button>
          )}
          {!isMobile && (
            <button onClick={onLogout} className="logout-button">
              {getMessage('logout')}
            </button>
          )}
        </div>
      </header>

      {isMobile && (
        <FloatingMenu
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          tabs={tabs}
          activeTab={activeTab}
          onTabSelect={onTabSelect}
          onLogout={onLogout}
        />
      )}
    </>
  )
}

export default Header
